import { format } from "date-fns/esm";

// Convert a date string to a JavaScript Date object
export const stringToDate = (textDate, textTime) => {
  let [year, month, day] = textDate.includes("-")
    ? textDate.split("-")
    : textDate.split("/");
  month = month - 1;
  const date = new Date(year, month, day);
  if (textTime) {
    let [hour, minute] = textTime.split(":");
    date.setHours(hour, minute);
  }
  return date;
};

// Check if string is ISO date format
export const isISODate = (dateString) => {
  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;
  return isoRegex.test(dateString);
};

// Convert a ISO date string to a formatted date string
export const isoDateToString = (isoDate, f) => {
  if (!isoDate) return "";
  if (!isISODate(isoDate)) return "Invalid Date";
  return format(new Date(isoDate), f || "MM/dd/yyyy");
};

const formatDate = (date) => {
  date = date.replaceAll("/", "-");
  if (date.length !== 10) {
    throw new Error("Invalid date format.");
  }
  if (date.split("-")[0].length !== 4) {
    const parts = date.split("-");
    return (date = parts[2] + "-" + parts[0] + "-" + parts[1]);
  } else return date;
};

const formatTime = (time) => {
  time = time.replaceAll("-", ":");
  if (time.length !== 8) {
    time += ":00";
  }
  if (time.length !== 8) {
    throw new Error("Invalid time format.");
  }

  return time;
};

export const constructDateObject = (date, time) => {
  if (!date || !time) throw new Error("Invalid Request: Missing Required Data");
  date = formatDate(date);
  time = formatTime(time);

  const dateRegex = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}?$/;
  const timeRegex = /^[0-9]{2}:[0-9]{2}:[0-9]{2}?$/;

  if (!dateRegex.test(date) || !timeRegex.test(time)) {
    throw new Error("Invalid Date or Time Format.");
  }
  return new Date(date + " " + time);
};

export const getISODate = (date, time) => {
  if (!date) throw new Error("Invalid Request: Missing Date");
  const dateObject = constructDateObject(date, time || "01:00:00");
  return dateObject.toISOString();
};
